import { useState } from "react";
import { NavLink } from "react-router-dom";

import {
	check_continuous_curve_bay,
	Render_measurtement,
	Toggle_measurtement_type,
	Render_summary,
	Render_status,
	Render_save_overlay,
} from "../js/bay-checker.js";

export default function Continuous_curve() {
	const [update, force_update] = useState(0);

	const [measurtement_ab, set_measurtement_ab] = useState("");
	const [measurtement_bc, set_measurtement_bc] = useState("");
	const [measurtement_ac, set_measurtement_ac] = useState("");

	const [measurtement_1a, set_measurtement_1a] = useState("");
	const [measurtement_c2, set_measurtement_c2] = useState("");

	let does_it_work = check_continuous_curve_bay(measurtement_ab, measurtement_bc, measurtement_ac);
	let the_summary = "(empty)";

	return (
		<div className="bay max_width">
			<div className="top">
				<div className="header">
					<NavLink className="back_to_home" to="/app/bay-checker/"></NavLink>
					<h2>
						<strong>curved</strong> bay
					</h2>
				</div>

				<div className="svg_wrap">
					<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 330 150">
						<path
							fill="#7BAABD"
							d="M63.8 117.3A4 4 0 0 1 60 120H4a4 4 0 0 1 0-8h53.2a117.6 117.6 0 0 1 5-11.2c4.1-8.2 10.4-19.2 19-30.3C98.5 48.5 125.8 26 165 26c39.2 0 66.5 22.5 83.8 44.5a175.6 175.6 0 0 1 24 41.5H326a4 4 0 0 1 0 8h-56a4 4 0 0 1-3.8-2.7v-.2l-.3-.7a97.8 97.8 0 0 0-5.3-12c-4-8-9.9-18.5-18.1-29C226 54.5 200.8 34 165 34s-61 20.5-77.5 41.5A167.5 167.5 0 0 0 63.8 117v.2Z"
						/>
						<path
							fill="#D4D0C4"
							fillRule="evenodd"
							clipRule="evenodd"
							d="m165 42-1.4 1.1a1.5 1.5 0 1 1-2-2.3l2.4-2a1.5 1.5 0 0 1 1-.3 1.5 1.5 0 0 1 1 .4l2.3 1.9a1.5 1.5 0 1 1-1.9 2.3l-1.4-1.2Zm8 2.7a1.5 1.5 0 0 0-1.9 2.3l4.8 3.9a1.5 1.5 0 1 0 1.9-2.3l-4.8-4Zm9.5 7.8a1.5 1.5 0 1 0-2 2.3l4.8 3.9a1.5 1.5 0 0 0 1.9-2.4l-4.7-3.8Zm9.4 7.7a1.5 1.5 0 0 0-1.9 2.3l4.7 4a1.5 1.5 0 1 0 2-2.4l-4.8-3.9Zm9.5 7.8a1.5 1.5 0 1 0-2 2.3l4.8 4a1.5 1.5 0 0 0 1.9-2.4l-4.7-3.9Zm9.4 7.8A1.5 1.5 0 0 0 209 78l4.7 3.9a1.5 1.5 0 1 0 2-2.3l-4.8-4Zm9.5 7.8a1.5 1.5 0 1 0-2 2.3l4.8 3.9a1.5 1.5 0 0 0 1.9-2.3l-4.7-4Zm9.4 7.7a1.5 1.5 0 1 0-1.9 2.4l4.7 3.8a1.5 1.5 0 1 0 2-2.3l-4.8-3.9Zm9.4 7.8a1.5 1.5 0 0 0-1.9 2.3l4.8 4a1.5 1.5 0 0 0 1.9-2.4l-4.8-3.9Zm9.5 7.8a1.5 1.5 0 1 0-2 2.3l2.4 2a1.5 1.5 0 1 0 2-2.4l-2.4-1.9Zm-169.8 4c-.5-.6-.4-1.5.2-2l2.4-2a1.5 1.5 0 0 1 2 2.3l-2.4 2c-.7.5-1.6.4-2.2-.2Zm7.1-5.8c-.5-.6-.4-1.6.2-2l4.8-4a1.5 1.5 0 1 1 1.9 2.3l-4.8 4c-.6.5-1.5.4-2-.3Zm9.5-7.8c-.6-.6-.5-1.5.2-2l4.7-4a1.5 1.5 0 0 1 1.9 2.4l-4.7 3.8c-.7.6-1.6.5-2.1-.2Zm9.4-7.7c-.5-.7-.4-1.6.2-2.1l4.7-4a1.5 1.5 0 1 1 2 2.4l-4.8 3.9c-.6.5-1.6.4-2-.2Zm9.5-7.8c-.6-.7-.5-1.6.2-2.1l4.7-4a1.5 1.5 0 0 1 1.9 2.4l-4.7 3.9c-.7.5-1.6.4-2.1-.2Zm9.4-7.8c-.5-.6-.4-1.6.2-2.1l4.7-3.9a1.5 1.5 0 1 1 2 2.3l-4.8 4c-.6.4-1.6.3-2.1-.3Zm9.4-7.8c-.5-.6-.4-1.6.3-2l4.7-4a1.5 1.5 0 0 1 1.9 2.3l-4.7 4c-.7.5-1.6.4-2.2-.3Zm9.5-7.7c-.5-.7-.4-1.6.2-2.2l4.7-3.8a1.5 1.5 0 1 1 2 2.3l-4.8 3.9c-.6.5-1.6.4-2.1-.2Zm9.4-7.8c-.5-.7-.4-1.6.2-2.1l4.8-4a1.5 1.5 0 1 1 1.9 2.4l-4.8 3.9c-.6.5-1.5.4-2-.2ZM88.5 120c0-.8.7-1.5 1.5-1.5h2.9a1.5 1.5 0 0 1 0 3H90c-.8 0-1.5-.7-1.5-1.5Zm8.7 0c0-.8.6-1.5 1.5-1.5h5.7a1.5 1.5 0 0 1 0 3h-5.7c-.9 0-1.5-.7-1.5-1.5Zm11.5 0c0-.8.7-1.5 1.5-1.5h5.8a1.5 1.5 0 1 1 0 3h-5.8c-.8 0-1.5-.7-1.5-1.5Zm11.5 0c0-.8.7-1.5 1.5-1.5h5.8a1.5 1.5 0 0 1 0 3h-5.8c-.8 0-1.5-.7-1.5-1.5Zm11.6 0c0-.8.6-1.5 1.5-1.5h5.7a1.5 1.5 0 1 1 0 3h-5.7c-.9 0-1.5-.7-1.5-1.5Zm11.5 0c0-.8.7-1.5 1.5-1.5h5.8a1.5 1.5 0 0 1 0 3h-5.8c-.8 0-1.5-.7-1.5-1.5Zm11.5 0c0-.8.7-1.5 1.5-1.5h5.8a1.5 1.5 0 1 1 0 3h-5.8c-.8 0-1.5-.7-1.5-1.5Zm11.6 0c0-.8.7-1.5 1.5-1.5h5.8a1.5 1.5 0 0 1 0 3h-5.8c-.8 0-1.5-.7-1.5-1.5Zm11.5 0c0-.8.7-1.5 1.5-1.5h5.8a1.5 1.5 0 1 1 0 3h-5.8c-.8 0-1.5-.7-1.5-1.5Zm11.6 0c0-.8.6-1.5 1.5-1.5h5.7a1.5 1.5 0 0 1 0 3H191c-.9 0-1.5-.7-1.5-1.5Zm11.5 0c0-.8.7-1.5 1.5-1.5h5.8a1.5 1.5 0 1 1 0 3h-5.8c-.8 0-1.5-.7-1.5-1.5Zm11.5 0c0-.8.7-1.5 1.5-1.5h5.8a1.5 1.5 0 0 1 0 3H214c-.8 0-1.5-.7-1.5-1.5Zm11.6 0c0-.8.6-1.5 1.5-1.5h5.7a1.5 1.5 0 1 1 0 3h-5.7c-.9 0-1.5-.7-1.5-1.5Zm11.5 0c0-.8.7-1.5 1.5-1.5h2.9a1.5 1.5 0 0 1 0 3h-2.9c-.8 0-1.5-.7-1.5-1.5Z"
						/>

						<g className="g_1">
							<path
								className="shape"
								d="M25 134c0-6-5-11-11-11H3v11a11 11 0 0 0 22 0Zm3 0a14 14 0 0 0-14-14H0v14a14 14 0 1 0 28 0Z"
							/>
							<path d="M17.5 136.8v2.2h-7.3v-2.2h2.6v-5.4l-.5.4a6.6 6.6 0 0 1-1.7.8h-.8v-2.2c.3 0 .5 0 .8-.2a7.6 7.6 0 0 0 2.2-1.5h2.4v8.1h2.3Z" />
						</g>

						<g className="g_2">
							<path
								className="shape"
								d="M316 145c6 0 11-5 11-11v-11h-11a11 11 0 0 0 0 22Zm0 3a14 14 0 0 0 14-14v-14h-14a14 14 0 1 0 0 28Z"
							/>
							<path d="m312.1 139 .1-1.5.5-1.2.8-1 1.4-1a93 93 0 0 1 2.3-1.2l.6-.5.2-.6-.2-.7-.6-.5a2 2 0 0 0-.9-.2 3 3 0 0 0-.8.2 3 3 0 0 0-1.3.7l-.5.5-1.5-1.7.7-.6 1-.5a6.8 6.8 0 0 1 2.8-.7 5 5 0 0 1 2.1.4 3 3 0 0 1 1.8 2.7c0 .4-.1.8-.3 1.1l-.5.9-.8.6-.8.5a33.9 33.9 0 0 0-2.5 1.5 3 3 0 0 0-.4.6h5.5v2.2H312Z" />
						</g>

						<g className="g_a">
							<path
								d="M74 145a11 11 0 0 0 0-22H63v11c0 6 5 11 11 11Zm0 3a14 14 0 1 0 0-28H60v14a14 14 0 0 0 14 14Z"
								className="shape"
							/>
							<path d="M72.3 127.2h2.5l4.7 12.8h-2.6l-1.2-3.2h-4.4L70 140h-2.6l4.8-12.8Zm3 7.9-1.8-5.3-1.8 5.3h3.6Z" />
						</g>

						<g className="g_b">
							<path
								className="shape"
								d="M157 8a11 11 0 0 0 0 15.6l7.8 7.8 7.8-7.8A11 11 0 1 0 157 8Zm-2-2a14 14 0 0 0 0 19.8l9.9 9.9 9.9-9.9A14 14 0 0 0 155 6Z"
							/>
							<path d="M169.8 18.5a3 3 0 0 1-.5 1.8c-.4.5-1 .9-1.6 1.1-.6.3-1.3.4-2 .4h-6.2V9h6.9c.6 0 1 .2 1.5.5a3.5 3.5 0 0 1 .9 4.5c-.3.6-.8 1-1.4 1.2a3.2 3.2 0 0 1 2.4 3.3Zm-2.5-.5c0-.3 0-.6-.2-.8a1 1 0 0 0-.5-.6c-.2-.2-.5-.3-.8-.3H162v3.4h3.7c.3 0 .6 0 .8-.2a1.7 1.7 0 0 0 .8-1.5Zm-5.3-6.9v3.3h3.3l.8-.2.5-.6c.2-.2.2-.5.2-.9 0-.3 0-.6-.2-.8a1.3 1.3 0 0 0-1.2-.8H162Z" />
						</g>

						<g className="g_c">
							<path className="shape" d="M256 123a11 11 0 1 0 11 11v-11h-11Zm0-3a14 14 0 1 0 14 14v-14h-14Z" />
							<path d="M250.9 133.5a6.5 6.5 0 0 1 3.6-5.8 6 6 0 0 1 2.7-.6c1.2 0 2.2.3 3 .8a5 5 0 0 1 2 2l-2 1.4a3 3 0 0 0-.8-1.2 3 3 0 0 0-1.1-.6 4 4 0 0 0-1.2-.2 3.4 3.4 0 0 0-2.8 1.4l-.7 1.4a5.5 5.5 0 0 0 0 3.1l.8 1.4 1.2 1c.5.2 1 .3 1.6.3.3 0 .8 0 1.2-.2a2 2 0 0 0 1-.6c.4-.3.7-.7.9-1.1l2 1.1c-.2.7-.6 1.2-1.2 1.7a6.8 6.8 0 0 1-4 1.3c-1 0-1.8-.2-2.5-.6a6.6 6.6 0 0 1-3.3-3.6c-.3-.8-.4-1.6-.4-2.4Z" />
						</g>
					</svg>
				</div>

				<Toggle_measurtement_type force_update={force_update} />
			</div>

			<div className="pusher" style={{ aspectRatio: "33 / 15" }}></div>

			<div className={does_it_work ? "the_measurements pass" : "the_measurements"}>
				<h4>Wall Measurements</h4>

				<div className="measurtement_wrapper">
					{["ab", "bc"].map((key) => {
						return (
							<Render_measurtement
								key={key}
								measurtement_name={key}
								measurtement={eval("measurtement_" + key)}
								set_measurtement={eval("set_measurtement_" + key)}
								force_update={force_update}
							/>
						);
					})}
				</div>

				<h4>Cross Measurements</h4>

				<div className="measurtement_wrapper">
					{["ac"].map((key) => {
						return (
							<Render_measurtement
								key={key}
								measurtement_name={key}
								measurtement={eval("measurtement_" + key)}
								set_measurtement={eval("set_measurtement_" + key)}
								force_update={force_update}
							/>
						);
					})}
				</div>

				<h4>Optional</h4>

				<div className="measurtement_wrapper">
					{["1a", "c2"].map((key) => {
						return (
							<Render_measurtement
								key={key}
								measurtement_name={key}
								measurtement={eval("measurtement_" + key)}
								set_measurtement={eval("set_measurtement_" + key)}
								force_update={force_update}
							/>
						);
					})}
				</div>

				<Render_status does_it_work={does_it_work} />

				{["ab", "bc", "ac"].map((key) => {
					let new_line = Render_summary({
						the_key: key,
						measurtement_mm: parseInt(eval("measurtement_" + key)),
					});
					if (the_summary == "(empty)") the_summary = new_line;
					else the_summary += new_line;

					// console.log(the_summary);
				})}

				<Render_save_overlay force_update={force_update} the_summary={the_summary} bay_type="Continuous Curve" />
			</div>
		</div>
	);
}
